/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCgvAcceptanceDto { 
    /**
     * User id who accepted this cgv
     */
    userId?: string;
    /**
     * Which legal cgv version
     */
    cgvId?: string;
    /**
     * Commission applied to this acceptance
     */
    commissionId?: string;
    /**
     * Acceptance type (ex: commission, refund)
     */
    type?: string;
}

